/* eslint-disable @typescript-eslint/naming-convention */
import { mockOfficeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-attach-scan';
const CONV_ID = 'conv-2';
const MD_BLOCK_ID = 'blk-attach-md';
const markdownText = "I've reviewed the uploaded files. The inspection report looks good, but the photo appears to have issues. Let me summarize my findings.";
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText),
    makeBlockEnd(MD_BLOCK_ID),
    makeStreamEnd(RESPONSE_ID, 1, mockOfficeAgent)
];
/**
 * Pre-seeded user messages with file attachments in various scan statuses
 */
export const userMessagesWithAttachments = [
    {
        id: 'msg-attach-1',
        role: 'user',
        content: 'Here are the inspection documents for review.',
        file_attachments: [
            {
                file_id: 'file-clean-1',
                file_name: 'Inspection-Report-2025.pdf',
                mime_type: 'application/pdf',
                file_size_bytes: 2500000,
                scan_status: 'clean'
            },
            {
                file_id: 'file-pending-1',
                file_name: 'building-photo.jpg',
                mime_type: 'image/jpeg',
                file_size_bytes: 1200000,
                scan_status: 'pending_scan'
            },
            {
                file_id: 'file-infected-1',
                file_name: 'suspicious-macro.xls',
                mime_type: 'application/vnd.ms-excel',
                file_size_bytes: 500000,
                scan_status: 'infected'
            },
            {
                file_id: 'file-scan-error-1',
                file_name: 'flagged-data.csv',
                mime_type: 'text/csv',
                file_size_bytes: 30000,
                scan_status: 'scan_error'
            }
        ],
        created_at: new Date(Date.now() - 60000).toISOString()
    }
];
export const scenario = {
    name: 'User Attachments — Scan Status',
    description: 'Shows a user message with file attachments in all four scan statuses: clean, pending_scan, infected, scan_error. ' +
        'The agent then responds with a review of the uploaded files.',
    conversations: mockConversations,
    userMessage: 'Here are the inspection documents for review.',
    agentIdentity: mockOfficeAgent,
    sseSequence,
    preSeededMessages: userMessagesWithAttachments
};
